import { createTheme } from "@mui/material/styles";
const customTheme = {
    typography: {
      fontFamily: [
        'Nunito Sans',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      fontWeightLight:400,
      fontWeightRegular:500,
      fontWeightMedium:600,
      fontWeightBold:700,
      fontWeightBolder:800,
      
      h1:{
          fontSize:"3.6rem",
        letterSpacing:"-0.08rem",
        fontWeight:800
      },
      h2:{
        fontSize:"2.4rem",
        letterSpacing:"-0.06rem",
        fontWeight:800
      },
      h3:{
        fontSize:"1.6rem",
        letterSpacing:"-0.04rem",
        fontWeight:800
      },
      h4:{
        fontSize:"1.4rem",
        letterSpacing:"-0.03rem",
        fontWeight:800
      },
      h5:{
        fontSize:"1.2rem",
        letterSpacing:"-0.03rem",
        fontWeight:800
      },
      h6:{
        fontSize:"1rem",
        letterSpacing:"-0.035rem",
        fontWeight:800
      },
      body1:{
          fontSize:"1rem",
          letterSpacing:"-0.02rem"
      },
      body2:{
        fontSize:"0.85rem",
        letterSpacing:"-0.01rem"
    },
      caption:{
          fontWeight:600
      },
      button:{
        fontWeight:800,
        textTransform:"capitalize"
      }
    },
  
    palette:{
      primary: {
        main: '#003910',
        light: '#82B879',
        contrastText: '#fff',
      },
      secondary: {
        main: '#d1d1d1',
        contrastText: '#474747',
      },
      success:{
        main:"#82B879"
      },
      error:{
        main:"#E96B63",
        500: "#E96B63"
      },
      gray:{
        300:"#e4e4e4"
      },
      background:{
          default:"#F5F5F6"
      }
    },
  
    shape:{
      borderRadius:4
    }
  
  }

  
const wyzrTheme = createTheme(customTheme);
export default wyzrTheme;